import React, { useMemo } from "react";
import WrapperExpand from "../WrapperExpand";
import { IExpand } from "../../../../types/expand.type";
import { Box, Button, Grid2, Stack } from "@mui/material";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { asyncDelete } from "../../../../utils/httpRequests";
import { useSelector } from "react-redux";
import TextInput from "../../input/TextInput";
import { stripHTML } from "../../../../utils/helpers";
import ImageGallery from "../../imageGallery/ImageGallery";
import ModalViewComment from "../../modal/ModalViewComment";

function ExpandFeed({ data, onOpenEdit, setLoad }: IExpand) {
  const app = useSelector((state: any) => state.app.data);
  const { token, profile } = useSelector((state: any) => state.auth);
  const { showAlert } = useAlertContext();

  const allowEditAndDelete =
    profile?.admin_app || profile?.email === data?.user_created;

  const cheDo = useMemo(() => {
    if (data?.mode === "private") {
      return "Chỉ mình tôi";
    } else if (data?.mode === "friends") {
      return "Bạn bè";
    } else if (data?.mode === "anonymous") {
      return "Ẩn danh";
    } else {
      return "Công khai";
    }
  }, [data?.mode]);

  const handleDelete = async () => {
    const resp = await asyncDelete({
      apiCode: "posts",
      id: data?._id,
      token,
      idApp: app?._id,
    });
    if (resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi xóa dữ liệu",
      });
    } else {
      showAlert({ type: "success", message: `Đã xóa thành công` });
      setLoad?.((prev) => prev + 1);
    }
  };

  return (
    <WrapperExpand
      data={data}
      sx={{ width: "800px" }}
      action={
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          gap={1}
          sx={{ py: 1 }}
        >
          {allowEditAndDelete && (
            <Button
              onClick={onOpenEdit}
              variant="contained"
              size="small"
              sx={{
                boxShadow: "none",
                textTransform: "none",
                color: "common.white",
                "&:hover": {
                  boxShadow: "none",
                },
              }}
            >
              Chỉnh sửa
            </Button>
          )}
          {allowEditAndDelete && (
            <Button
              onClick={() => {
                showAlert({
                  title: "Xác nhận xóa",
                  type: "info",
                  message: "Bạn có chắc muốn xóa dòng này không ?",
                  onConfirm: handleDelete,
                });
              }}
              variant="contained"
              size="small"
              color="error"
              sx={{
                boxShadow: "none",
                textTransform: "none",
                color: "common.white",
                "&:hover": {
                  boxShadow: "none",
                },
              }}
            >
              Xóa
            </Button>
          )}
        </Stack>
      }
    >
      <Stack gap={2} sx={{ width: "100%" }}>
        {/* Thong tin chung */}
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Stack gap={2}>
              <TextInput
                readOnly
                labelWidth="25%"
                label="Tên người tạo"
                value={data?.name_user_created}
              />

              <TextInput
                readOnly
                labelWidth="25%"
                label="Chế độ"
                value={cheDo}
              />
              <TextInput
                readOnly
                multiline
                maxRows={5}
                labelWidth="25%"
                label="Nội dung"
                value={stripHTML(data?.description)}
              />
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Stack gap={2}>
              <TextInput
                readOnly
                labelWidth="25%"
                label="Lượt xem"
                value={data?.viewCount}
              />
              <TextInput
                readOnly
                labelWidth="25%"
                label="Lượt thích"
                value={data?.likeCount}
              />
              <TextInput
                readOnly
                labelWidth="25%"
                label="Lượt comment"
                value={data?.commentCount}
                endAdornment={<ModalViewComment post={data} />}
              />
            </Stack>
          </Grid2>
        </Grid2>
        {/* Hinh anh */}
        {data?.photos?.length > 0 && (
          <Box
            sx={{
              p: 1,
              borderRadius: "10px",
            }}
          >
            <ImageGallery
              maxItem={3}
              items={(data?.photos || []).map((item: any) => item.url)}
            />
          </Box>
        )}
      </Stack>
    </WrapperExpand>
  );
}

export default ExpandFeed;
